import { Navigate } from "react-router-dom";
import ShowQuestions from "layouts/quizTitles/ShowQuestions.js";
import PresentationTitles from "../prof/presentationTitles";
import PresentationMakerPage from "../prof/presentationTitles/PresentationMakerPage";
import PresentationMobileViewPage from "../prof/presentationTitles/PresentationMobileViewPage";
import ProfStats from "../prof/ProfStats";
import QuizSystem from "../prof/QuizSystem";
import HeatMap from "../prof/HeatMap";
import QuizResults from "../prof/QuizResults";
import QuizInsights from "../prof/QuizInsights";
import Titles from "../layouts/titles";
import ShowTile from "../layouts/titles/showTile/index";
import ShowThreeD from "../layouts/titles/ShowThreeD";
import MyLibraryPage from "../layouts/myLibrary";
import CommunityPage from "../layouts/community";
import ActivityAnalyticsPage from "../layouts/activityAnalytics";
import MicrolabCopilotHub from "../layouts/microlabCopilot";
import MicrolabCopilotProcessing from "../layouts/microlabCopilot/ProcessingScreen";
import MicrolabCopilotStudyPack from "../layouts/microlabCopilot/StudyPackScreen";

import Icon from "@mui/material/Icon";
import Professors from "../layouts/professors";
import Students from "../layouts/students";

const universityRoutes = [
  {
    route: "/dashboard",
    key: "dashboardRedirect",
    component: <Navigate to="/stats" replace />,
  },
  {
    type: "collapse",
    name: "Stats",
    key: "stats",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/stats",
    component: <ProfStats />,
  },
  {
    type: "collapse",
    name: "Microlab Copilot",
    key: "microlab-copilot",
    hideInSidenav: true,
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/microlab-copilot",
    component: <MicrolabCopilotHub />,
  },
  {
    type: "collapse",
    name: "My Library",
    key: "my-library",
    icon: <Icon fontSize="small">folder</Icon>,
    route: "/my-library",
    component: <MyLibraryPage />,
  },
  {
    type: "collapse",
    name: "Community",
    key: "community",
    icon: <Icon fontSize="small">forum</Icon>,
    route: "/community",
    component: <CommunityPage />,
  },
  {
    type: "collapse",
    name: "Quiz",
    key: "quiz",
    icon: <Icon fontSize="small">quiz</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Course Catalog",
        key: "quiz-titles",
        route: "/quiz/titles",
        component: <QuizSystem stage={0} />,
      },
      {
        type: "collapse",
        name: "Question Bank",
        key: "quiz-questions",
        route: "/quiz/questions",
        component: <QuizSystem stage={1} />,
      },
      {
        type: "collapse",
        name: "Create Quiz",
        key: "quiz-create",
        route: "/quiz/create",
        component: <QuizSystem stage={2} />,
      },
      {
        type: "collapse",
        name: "Heat map",
        key: "quiz-heatmap",
        route: "/quiz/heatmap",
        component: <HeatMap />,
      },
      {
        type: "collapse",
        name: "Results",
        key: "quiz-results",
        route: "/quiz/results",
        component: <QuizResults />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Presentations",
    key: "presentationTitles",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/presentationTitles",
    component: <PresentationTitles />,
  },
  {
    type: "collapse",
    name: "Quiz Insights",
    key: "quiz-insights",
    hideInSidenav: true,
    icon: <Icon fontSize="small">psychology</Icon>,
    route: "/quiz/insights",
    component: <QuizInsights />,
  },
  {
    type: "collapse",
    name: "Professors",
    key: "professors",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/professors",
    component: <Professors />,
  },
  {
    type: "collapse",
    name: "Students",
    key: "students",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/students",
    component: <Students />,
  },
  {
    type: "collapse",
    name: "App Analytics",
    key: "app-analytics",
    icon: <Icon fontSize="small">monitoring</Icon>,
    route: "/app-analytics",
    component: <ActivityAnalyticsPage />,
    allowedRoles: ["admin"],
  },
  
  {
    name: "presentationMakerPage",
    key: "presentationMakerPage",
    route: "/presentationMakerPage/:id",
    component: <PresentationMakerPage />,
  },
  {
    name: "presentationMobileView",
    key: "presentationMobileView",
    route: "/presentationMobileView/:id",
    component: <PresentationMobileViewPage />,
  },
  
  {
    name: "threeDTitles",
    key: "threeDTitles",
    route: "/threeDTitles",
    component: <Navigate to="/titles?segment=models" replace />,
  },
  {
    type: "collapse",
    name: "Anatomy",
    key: "anatomyTitles",
    icon: <Icon fontSize="small">accessibility_new</Icon>,
    route: "/anatomyTitles",
    component: <Titles type="anatomy" readOnly />,
  },
  {
    type: "collapse",
    name: "Histology",
    key: "titles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/titles",
    component: <Titles type="his" readOnly />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" readOnly />,
  },

  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showQuestions",
    key: "showQuestions",
    route: "/showQuestions/:id/:lang",
    component: <ShowQuestions />,
  },
  // Microlab Copilot hidden routes (no sidebar entry).
  {
    name: "microlabCopilotProcessing",
    key: "microlabCopilotProcessing",
    route: "/microlab-copilot/processing/:materialId",
    component: <MicrolabCopilotProcessing />,
  },
  {
    name: "microlabCopilotStudyPack",
    key: "microlabCopilotStudyPack",
    route: "/microlab-copilot/study/:materialId",
    component: <MicrolabCopilotStudyPack />,
  },
];

export default universityRoutes;
